if (window.__POWERED_BY_QIANKUN__) {
  // __webpack_public_path__ = window.__INJECTED_PUBLIC_PATH_BY_QIANKUN__;
  // eslint-disable-next-line no-undef
  __webpack_public_path__ =
    process.env.NODE_ENV === "development" ? "http://localhost:4000/" : "/lce/";
  // console.log("__webpack_public_path__:", __webpack_public_path__);
}
